import { render, staticRenderFns } from "./ChangeRecordForm.vue?vue&type=template&id=2d7ee480&"
import script from "./ChangeRecordForm.vue?vue&type=script&lang=js&"
export * from "./ChangeRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRecordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChangeRecordForm.vue"
export default component.exports